import React, { useEffect } from "react";
import { redirect } from "react-router";

interface Props {
  action: string;
  data: any;
}

export default function MessageController(props: Props) {
  const { action, data } = props;

  useEffect(() => {
    actionController();

  }, []);

  function actionController() {
    if (action === "location") {
      actionLocation();
    } else if (action === "alarm") {
      actionAlarm();
    }
  }

  function actionLocation() {
    return redirect(data);
  }

  function actionAlarm() {
    alert(data);
  }

  return <div />;
}
